import { Contact, ContactType, ParentContact } from './contact';
import { UserImportRequest } from '../../requests';
import { RoleEntity, SecurityRole } from '../../security';
import { Entity } from '../';
import * as uuid from 'uuid';
import * as Enumerable from 'linq';

export class ContactImportUtility {


    public static getContactsFromImport(user: UserImportRequest, role: SecurityRole, pricebook: Entity): Contact[] {

        const parentId = uuid.v4();

        const employee = ContactImportUtility.getEmployeeContact(user, role);
        const subcontractor = ContactImportUtility.getSubcontractor(user, pricebook, parentId);
        const loginContact = ContactImportUtility.getLoginContact(user, role, parentId);

        const contacts = Enumerable.from([employee, subcontractor, loginContact])
            .where(x => !!x?._id)
            .toArray();

        return contacts;
    }

    private static getEmployeeContact(user: UserImportRequest, role: RoleEntity): Contact {

        if (user.type !== ContactType.Employee)
            return null;

        const contact = {
            _id: user._id,
            active: true,
            type: ContactType.Employee,
            name: `${user.firstName} ${user.lastName}`,
            firstName: user.firstName,
            lastName: user.lastName,
            mobile: user.mobile,
            email: user.email,
            username: user.email,
            address: null,
            role: role,
            dispatching: {
                enabled: user.emailOnly
            },
            scheduling: {
                enabled: false,
                address: null
            },
            login: {
                invite: false
            },
            hideBuyPrice: user.hidePrices
        } as Contact;

        return contact;
    }

    private static getSubcontractor(user: UserImportRequest, pricebook: Entity, parentId: string): Contact {

        if (user.type === ContactType.Employee)
            return null;

        const name = user?.companyName ?? `${user.firstName} ${user.lastName}`;

        const contact = {
            _id: parentId,
            active: true,
            type: user.type,
            name: name,
            phone: user.phone,
            email: user.email,
            username: user.email,
            address: null,
            pricebook: pricebook,
            dispatching: {
                enabled: user.emailOnly
            },
            scheduling: {
                enabled: true,
                address: null
            },
            hideBuyPrice: user.hidePrices
        } as Contact;

        return contact;
    }

    private static getLoginContact(user: UserImportRequest, role: SecurityRole, parentId: string): Contact {

        if (user.type === ContactType.Employee)
            return null;

        const parent = {
            _id: parentId,
            type: user.type,
            role: {
                _id: role._id,
                type: role.type,
                name: role.name
            },
            login: {
                invite: false
            },
            companies: []
        } as ParentContact;

        const name = user?.companyName ?? `${user.firstName} ${user.lastName}`;

        const contact = {
            _id: user._id,
            active: true,
            type: ContactType.LoginContact,
            name: name,
            firstName: user.firstName,
            lastName: user.lastName,
            mobile: user.mobile,
            email: user.email,
            username: user.email,
            address: null,
            parents: [parent]
        } as Contact;

        return contact;
    }

}